import { render, staticRenderFns } from "./VinPurCart.vue?vue&type=template&id=c87b1c3e"
import script from "./VinPurCart.vue?vue&type=script&lang=js"
export * from "./VinPurCart.vue?vue&type=script&lang=js"
import style0 from "./VinPurCart.vue?vue&type=style&index=0&id=c87b1c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports